import script from "./FitnessScoreManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./FitnessScoreManagement.vue?vue&type=script&setup=true&lang=js"

import "./FitnessScoreManagement.vue?vue&type=style&index=0&id=e6878c5c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e6878c5c"]])

export default __exports__